import { getAxiosInstance } from "../ApiConfig";

async function CreateSegment(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createSegment`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function UpdateSegment(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateSegment/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function DeleteSegment(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteSegment/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FindOnebySegmentId(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findOnebySegmentId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAllSegmentByUser() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSegmentByUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllSegmentPagination(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSegmentByUser?page=${page}&limit=${limit}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllSegmentSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSegmentByUser?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllSegmentPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSegmentByUser?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllData(segmentId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSegmentModuleData/${segmentId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllDataPagination(segmentId, page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSegmentModuleData/${segmentId}?page=${page}&limit=${limit}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllDataSearch(segmentId, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSegmentModuleData/${segmentId}?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllDataPaginationSearch(segmentId, page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSegmentModuleData/${segmentId}?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    AllSegmentPagination,
    FetchAllSegmentSearch,
    AllSegmentPaginationSearch,
    CreateSegment,
    UpdateSegment,
    DeleteSegment,
    FindOnebySegmentId,
    findAllSegmentByUser,
    FetchAllData,
    AllDataPagination,
    FetchAllDataSearch,
    AllDataPaginationSearch,
}